// B2B Shared Constants

export const B2B_ROUTES = {
  LOGIN: '/gcb/login',
  REGISTER: '/gcb/register',
  DASHBOARD: '/gcb/dashboard',
  PROFILE: '/gcb/profile',
  PARTICIPANTS: '/gcb/participants',
  EVENTS: '/gcb/events',
  ADMIN: '/gcb/admin',
  WAITING_APPROVAL: '/gcb/waiting-approval',
  EMAIL_VERIFICATION: '/gcb/verify-email',
  FORGOT_PASSWORD: '/gcb/forgot-password',
  RESET_PASSWORD: '/gcb/reset-password'
} as const;

export const B2B_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  SUSPENDED: 'suspended'
} as const;

export const B2B_ROLES = {
  USER: 'user',
  ADMIN: 'admin',
  SUPER_ADMIN: 'super_admin'
} as const;

export const B2B_FORM_VALIDATION = {
  NAME_MIN_LENGTH: 2,
  NAME_MAX_LENGTH: 50,
  PASSWORD_MIN_LENGTH: 8,
  PHONE_PATTERN: /^[+]?[1-9][\d]{0,15}$/,
  EMAIL_PATTERN: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  URL_PATTERN: /^https?:\/\/.+/
} as const;

export const B2B_SUBGROUPS = [
  'restaurants_and_entertainment',
  'recruitment',
  'tax',
  'finance_and_accounting',
  'healthcare',
  'construction_and_development',
  'investments',
  'it',
  'real_estate',
  'insurance',
  'legal',
  'marketplace',
  'travel',
  'art_and_culture',
  'manufacturing',
  'startups',
  'engineering',
  'banking_and_finance',
  'security',
  'sales',
  'marketing',
  'other'
] as const;

export const B2B_POSITION_OPTIONS = [
  'owner',
  'ceo',
  'chiefOfBoard',
  'anyCxo',
  'other'
] as const;

export const B2B_INTERESTED_IN_OPTIONS = [
  'investments',
  'clients',
  'partnerships',
  'technologies',
  'ventures',
  'networking',
  'others'
] as const;

export type B2BRoute = typeof B2B_ROUTES[keyof typeof B2B_ROUTES];
export type B2BStatus = typeof B2B_STATUS[keyof typeof B2B_STATUS];
export type B2BRole = typeof B2B_ROLES[keyof typeof B2B_ROLES];
export type B2BSubgroup = typeof B2B_SUBGROUPS[number];
export type B2BPosition = typeof B2B_POSITION_OPTIONS[number];
export type B2BInterestedIn = typeof B2B_INTERESTED_IN_OPTIONS[number];

// Country Codes (NEW - Replaces duplicate country code definitions)
export * from './B2BCountryCodes';
